<template>
    <!-- PC -->
    <div v-if="!mobile">
        <div>
            <div class="lkt-manual env_VN">
                <div>
                    <ul>
                        <li @click="scrollToElement('vn-1')">Cách vào màn hình [Thông tin khóa học]</li>
                        <li @click="scrollToElement('vn-2')">Tìm kiếm khóa học</li>
                        <li @click="scrollToElement('vn-3')">Thông tin khóa học</li>
                        <li @click="scrollToElement('vn-4')">Danh sách học viên</li>
                        <li @click="scrollToElement('vn-5')">Danh sách bài tập</li>
                    </ul>
                </div>
                <div id="vn-1">
                    <h1>1.Cách vào màn hình [Thông tin khóa học]</h1>
                </div>
                <div><img src="/static\images\vi\newManual\manageCourseManual-1.png" alt="" /></div>
                <div>
                    <p>① Nhấn vào [Avatar] hoặc [Tên người dùng] để mở menu quản lý dành cho giáo viên.</p>
                    <p>② Khi nhấn vào mục [Thông tin khóa học ] thì sẽ chuyển đến màn hình [Thông tin khóa học] gồm tất cả các khóa học mà giáo viên phụ trách.</p>
                </div>
                <div id="vn-2">
                    <h1>2.Tìm kiếm khóa học</h1>
                </div>
                <div><img src="/static\images\vi\newManual\manageCourseManual-2.png" alt="" /></div>
                <div>
                    <p>Nhập tên khóa học muốn tìm kiếm</p>
                </div>
                <div id="vn-3">
                    <h1>3.Thông tin khóa học</h1>
                </div>
                <div>
                    <p>
                        <b><i>3.1 Nội dung chi tiết</i></b>
                    </p>
                </div>
                <div><img src="/static\images\vi\newManual\manageCourseManual-3.png" alt="" /></div>
                <div>
                    <p>Nhấn vào nút [Nội dung chi tiết] để đến màn hình [Chi tiết khóa học]</p>
                </div>
                <div>
                    <p>
                        <b><i>3.2 Xuất thành tích học viên</i></b>
                    </p>
                </div>
                <div><img src="/static\images\vi\newManual\manageCourseManual-4.png" alt="" /></div>
                <div id="vn-4">
                    <h1>4.Danh sách học viên</h1>
                </div>
                <div>
                    <p>
                        <b><i>4.1 Tìm kiếm theo từ khóa</i></b>
                    </p>
                </div>
                <div><img src="/static\images\vi\newManual\manageCourseManual-5.png" alt="" /></div>
                <div>
                    <p>Nhập tên học viên muốn tìm kiếm</p>
                </div>
                <div>
                    <p>
                        <b><i>4.2 Sắp xếp theo trạng thái của học viên</i></b>
                    </p>
                </div>
                <div><img src="/static\images\vi\newManual\manageCourseManual-6.png" alt="" /></div>
                <div>
                    <p>Nhấn vào các nút để hiển thị hoặc không hiển thị các học viên ứng với trạng thái</p>
                </div>
                <div>
                    <p>
                        <b><i>4.3 Chi tiết khóa học đối của học viên</i></b>
                    </p>
                </div>
                <div><img src="/static\images\vi\newManual\manageCourseManual-7.png" alt="" /></div>
                <div>
                    <p>① Nhập từ khóa vào khung tìm kiến để tìm học viên muốn tìm.</p>
                    <p>&nbsp; Từ khóa có thể là tên của học viên, hoặc từ khóa liên quan đến phần giới thiệu của học viên.</p>
                    <p>② Nhấn vào học viên cần xem nội dung chi tiết.</p>
                </div>
                <div>
                    <p>
                        <b><i>4.4 Danh sách câu trả lời sai của bài tập nhỏ</i></b>
                    </p>
                </div>
                <div><img src="/static\images\vi\newManual\manageCourseManual-8.png" alt="" /></div>
                <div>
                    <p>Nhấn vào tỉ lệ điểm để xem danh sách câu sai bài tập nhỏ của học viên</p>
                </div>
                <div id="vn-5">
                    <h1>5. Danh sách bài tập</h1>
                </div>
                <div>
                    <p>
                        <b><i>5.1 Tìm kiếm câu hỏi</i></b>
                    </p>
                </div>
                <div><img src="/static\images\vi\newManual\manageCourseManual-9.png" alt="" /></div>
                <div>
                    <p>① Nhập ID câu hỏi muốn tìm kiếm</p>
                    <p>② Nhập tiêu đề câu hỏi cần tìm kiếm</p>
                    <p>③ Chọn hình thức câu hỏi cần tìm kiếm</p>
                    <p>④ Chọn loại câu hỏi cần tìm kiếm</p>
                    <p>⑤ Chọn giáo viên tạo câu hỏi cần tìm kiếm</p>
                    <p>⑥ Chọn ngày tạo câu hỏi cần tìm kiếm</p>
                    <p>⑦ Chọn chương chứa câu hỏi cần tìm kiếm</p>
                    <p>⑧ Chọn loại nội dung có trong câu hỏi cần tìm kiếm</p>
                    <p>⑨ Các điều kiện tìm kiếm và nội dung trở về trạng thái ban đầu</p>
                </div>
                <div>
                    <p>
                        <b><i>5.2 Chi tiết câu hỏi</i></b>
                    </p>
                </div>
                <div><img src="/static\images\vi\newManual\manageCourseManual-10.png" alt="" /></div>
                <div>
                    <p>Nhấn vào câu hỏi cần xem nội dung chi tiết</p>
                </div>
            </div>
        </div>
    </div>
    <!-- Mobile -->
    <div v-else>
        <div>
            <div class="lkt-manual env_VN">
                <div>
                    <ul>
                        <li @click="scrollToElement('vn-1')">Cách vào màn hình [Thông tin khóa học]</li>
                        <li @click="scrollToElement('vn-2')">Tìm kiếm khóa học</li>
                        <li @click="scrollToElement('vn-3')">Thông tin khóa học</li>
                        <li @click="scrollToElement('vn-4')">Danh sách học viên</li>
                        <li @click="scrollToElement('vn-5')">Danh sách bài tập</li>
                    </ul>
                </div>
                <div id="vn-1"><p>1. Cách vào trang quản lý khóa học.</p></div>
                <div><p>① Click icon Menu ở phía dưới màn hình, thì thanh Menu như trên sẽ xuất hiện từ phía bên trái màn hình.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\manage_lesson_1_1.png" alt="" /></div>
                <div><p>② Nhấn vào ô [Thông tin khóa học] để di chuyển đến trang thông tin học viên.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\manage_lesson_1_2.png" alt="" /></div>
                <div id="vn-2"><p>2. Tìm kiếm khóa học.</p></div>
                <div><p>Nhập tên khóa học muốn tìm kiếm.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\manage_lesson_2_1.png" alt="" /></div>
                <div id="vn-3"><p>3. Thông tin khoá học.</p></div>
                <div><p>① Chọn khoá học cần xem.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\manage_lesson_3_1.png" alt="" /></div>
                <div><p>② Hiểm thị thông tin khóa học vừa chọn.</p></div>
                <div><p>● Nút [Nội dung chi tiết] Khi nhấn vào sẽ di chuyển đến mà hình chi tiết khóa học.</p></div>
                <div><p>● Nội dung khóa học.</p></div>
                <div><p>● Thời gian khóa học: Hiển thị thời gian bắt đầu và kết thúc khóa học.</p></div>
                <div><p>● Giáo viên phụ trách: Tên giáo viên phụ trách khóa học.</p></div>
                <div><p>● Tổng số học viên tham gia khóa học.</p></div>
                <div><p>● Học viên chưa học.</p></div>
                <div><p>● Học viên đang học.</p></div>
                <div><p>● Học vien đã học xong.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\manage_lesson_3_2.png" alt="" /></div>
                <div id="vn-4"><p>4. Danh sách học viên.</p></div>
                <div><p>4.1 Tìm kiếm theo từ khóa.</p></div>
                <div><p>① Nhập tên học viên muốn tìm kiếm.</p></div>
                <div><p>② Nhấn vào các nút để hiển thị hoặc không hiển thị các học viên ứng với trạng thái.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\manage_lesson_4_1_1.png" alt="" /></div>
                <div><p>4.2 Chi tiết khóa học đối của học viên.</p></div>
                <div><p>① Nhấn vào học viên cần xem nội dung chi tiết.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\manage_lesson_4_2_1.png" alt="" /></div>
                <div><p>② Hiển thị nội dung chi tiết học viên trong khóa học đó. Tại đây có thể xem được tiến độ của học viên, xem lịch sử dự thi của học viên trong khóa học đó và xem được học viên đã học nội dung và làm bài tập nào trong khóa học đó.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\manage_lesson_4_2_2.png" alt="" /></div>
                <div id="vn-5"><p>5. Danh sách bài tập.</p></div>
                <div><p>5.1. Tìm kiếm câu hỏi.</p></div>
                <div><p>Nhập đầy đủ thông tin mà bạn muốn tìm kiếm.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\manage_lesson_5_1_1.png" alt="" /></div>
                <div><p>5.2 Xem câu hỏi.</p></div>
                <div><p>① Chọn câu hỏi cần xem.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\manage_lesson_5_2_1.png" alt="" /></div>
                <div><p>② Hiển thị thông tin câu hỏi vừa mới chọn.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\manage_lesson_5_2_2.png" alt="" /></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {};
        },
        components: {},
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        async created() {},
        watch: {},
        methods: {
            scrollToElement(id) {
                let element = document.getElementById(id);
                element.scrollIntoView();
            },
        },
    };
</script>
<style scoped>
    .lkt-manual div {
        margin-bottom: 10px;
    }
    .lkt-manual p {
        line-height: 25px;
    }
    .lkt-manual ul {
        margin-left: 20px;
        list-style: square;
        font-size: 12pt;
    }
    ul li {
        cursor: pointer;
    }
    img {
        width: 100%;
    }
    p {
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/manual/content/vi/manageCourse_manual.vue